import { useDisclosure, useToast } from "@chakra-ui/react";
import { parsedReceiving } from "helpers/parsed/parsedReceiving";
import {
  Fornecedor,
  IReceivingSectorContext,
  ParamsDataItem,
} from "Interfaces/Providers/receivingSector";
import { createContext, ReactNode, useCallback, useState } from "react";
import inventory from "services/inventory";
import receiving from "services/receiving";
import { useImmer } from "use-immer";
 
interface Auth0ProviderProps {
  children: ReactNode;
}
 
const ReceivingSectorProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
 
  const [loading, setLoading] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingSupplier, setLoadingSupplier] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingGPSupplier, setLoadingGPSupplier] = useState(false);
  const [isFirstData, setFirstData] = useState(true);
  const [newEntry, setNewEntry] = useState<Fornecedor | null>(null);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [filename, setFilename] = useState("Orçamento Comercial - Relatório");
  const [editEntry, setEditEntry] = useState<Fornecedor | null>(null);
  const [editIdx, setEditIdx] = useState<number | null>(null);
 
  const [data, updateData] = useImmer<any[]>([]);
  const [dataSupplier, updateDataSupplier] = useImmer<any[]>([]);
  const [dataScruture, updateDataScruture] = useImmer<any[]>([]);
  const [limits, updateLimits] = useImmer<any[]>([]);
  const [loadingHistoric, setLoadingHistoric] = useState(false);
  const [dataOriginal, updateDataOriginal] = useImmer<any[]>([]);
  const [dataGPSupplier, updateDataGPSupplier] = useImmer<any[]>([]);
  const [dataUserSupplier, updateDataUserSupplier] = useImmer<any[]>([]);
 
  const [dataHistoric, updateDataHistoric] = useImmer<any[]>([]);
  const [paramsDataOriginal, setParamsDataOriginal] = useState<
    ParamsDataItem[]
  >([]);
  const [paramsData, setParamsData] = useState<ParamsDataItem[]>([]);
  const [originalLimits, setOriginalLimits] = useState<any[]>([]); // Store original limits
  const [params, setParams] = useState<{
    storeId: number;
    ferragem: {
      receivingSectorId: number;
      angela: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      everton: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      danubia: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      mappa: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      pedro: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
    };
    chaparia: {
      receivingSectorId: number;
      angela: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      everton: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      danubia: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      mappa: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
      pedro: {
        id: number;
        productManagerId: number;
        segunda: number;
        terca: number;
        quarta: number;
        quinta: number;
        sexta: number;
      };
    };
  }>({
    storeId: 0,
    ferragem: {
      receivingSectorId: 1,
      angela: {
        id: 0,
        productManagerId: 13,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      everton: {
        id: 6,
        productManagerId: 6,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      danubia: {
        id: 3,
        productManagerId: 3,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      mappa: {
        id: 24,
        productManagerId: 24,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      pedro: {
        id: 0,
        productManagerId: 35,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
    },
    chaparia: {
      receivingSectorId: 2,
      angela: {
        id: 0,
        productManagerId: 13,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      everton: {
        id: 0,
        productManagerId: 6,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      danubia: {
        id: 0,
        productManagerId: 3,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      mappa: {
        id: 0,
        productManagerId: 24,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
      pedro: {
        id: 0,
        productManagerId: 35,
        segunda: 0,
        terca: 0,
        quarta: 0,
        quinta: 0,
        sexta: 0,
      },
    },
  });
 
  const getDataByIdStore = useCallback(
    async (id: number) => {
      setLoading(true);
      setFirstData(false);
      let newParams = {};
 
      receiving
        .getReceiving()
        .then((response) => {
          updateData(parsedReceiving(response.data?.data));
          updateDataOriginal(response.data?.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [updateData, updateDataOriginal]
  );
  const getData = useCallback(async () => {
    setLoading(true);
    setFirstData(false);
 
    receiving
      .getReceiving()
      .then((response) => {
        updateData(parsedReceiving(response.data?.data));
        updateDataOriginal(response.data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [updateData, updateDataOriginal]);
 
  const getDataStructure = useCallback(async () => {
    setLoading(true);
    setFirstData(false);
    receiving
      .getReceivingStructure()
      .then((response) => {
        const sortedData = response.data?.data.sectors.sort(
          (
            a: { receivingSectorId: number; productManagerId: number },
            b: { receivingSectorId: number; productManagerId: number }
          ) => {
            if (a.receivingSectorId === b.receivingSectorId) {
              return a.productManagerId - b.productManagerId;
            } else {
              return a.receivingSectorId - b.receivingSectorId;
            }
          }
        );
 
        updateDataScruture(sortedData);
        const limitsData = response.data?.data.limits || [];
        updateLimits(limitsData); // NOVO
        setOriginalLimits([...limitsData]); // Store original limits
        setLoading(false);
      })
 
      .catch(() => {
        setLoading(false);
      });
  }, [updateDataScruture, updateLimits]);
 
  const postData = useCallback(
    async (obj: any) => {
      setLoadingUpdate(true);
      setFirstData(false);
 
      var newObj = { sectors: dataScruture, limits };
 
      receiving
        .postInventory(newObj)
        .then((response) => {
          setIsOpenCreate(false);
          toast({
            title: "Setor de recebimento cadastrado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          getDataStructure();
          getData();
          setLoadingUpdate(false);
        })
        .catch((e: any) => {
          const { data } = e.response;
 
          const message = data?.message
            ? data?.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
          toast({
            title: "Error.",
            description: message,
            position: "top",
            status: "error",
            duration: 2000,
 
            isClosable: true,
          });
          setLoadingUpdate(false);
        });
    },
    [dataScruture, getData, getDataStructure, limits, toast]
  );
 
  const putData = useCallback(
    async (obj: any) => {
      setLoadingUpdate(true);
 
      setFirstData(false);
      const newObj = { sectors: paramsData, limits };
      var idUpdate =
        paramsData[0] !== null && paramsData[0] !== undefined
          ? paramsData[0].storeId
          : 0;
 
      receiving
        .putInventory(newObj, paramsData[0].storeId)
        .then((response) => {
          toast({
            title: "Setor de recebimento atualizado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          getReceivingStoreUpdate(idUpdate);
          getData();
          setLoadingUpdate(false);
        })
        .catch((e: any) => {
          const { data } = e.response;
 
          const message = data?.message
            ? data?.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
          toast({
            title: "Error.",
            description: message,
            position: "top",
            status: "error",
            duration: 2000,
 
            isClosable: true,
          });
          setLoadingUpdate(false);
        });
    },
    [getData, limits, paramsData, toast]
  );
 
  const deleteData = useCallback(
    async (id: number) => {
      // setLoading(true);
      setFirstData(false);
      let newParams = {};
 
      inventory
        .deleteInventory(id)
        .then((response) => {
          getData();
          toast({
            title: "Setor de recebimento deletado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch((e: any) => {
          const { data } = e.response;
 
          const message = data?.message
            ? data?.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
          toast({
            title: "Error.",
            description: message,
            position: "top",
            status: "error",
            duration: 2000,
 
            isClosable: true,
          });
          setLoading(false);
        });
    },
    [updateData]
  );
 
  const handleDynamic = useCallback(
    (id: any, day: keyof ParamsDataItem, value: any) => {
      setParamsData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, [day]: Number(value) } : item
        )
      );
    },
    []
  );
 
  const handleDynamicCreate = useCallback(
    (
      productManagerId: number,
      receivingSectorId: number,
      day: keyof ParamsDataItem,
      value: any
    ) => {
      updateDataScruture((prevData) =>
        prevData.map((item) =>
          item.productManagerId === productManagerId &&
          item.receivingSectorId === receivingSectorId
            ? { ...item, [day]: Number(value) }
            : item
        )
      );
    },
    [updateDataScruture]
  );
 
  const handleStore = useCallback(
    (value: any) => {
      const storeId = parseInt(value?.value);
 
      // Atualiza os setores
      updateDataScruture((prevData) =>
        prevData.map((item) => ({
          ...item,
          storeId,
        }))
      );
 
      // Atualiza os limites
      updateLimits((prev) =>
        prev.map((limit) => ({
          ...limit,
          storeId,
        }))
      );
    },
    [updateDataScruture, updateLimits]
  );
 
  const getDataHistoric = useCallback(async () => {
    setLoadingHistoric(true);
    setFirstData(false);
 
    receiving
      .getReceivingHistoric()
      .then((response) => {
        updateDataHistoric(response.data?.data);
        setLoadingHistoric(false);
      })
      .catch(() => {
        setLoadingHistoric(false);
      });
  }, [updateDataHistoric]);
 
  const getReceivingStoreUpdate = useCallback(
    (id: any) => {
      setLoadingEdit(true);
      receiving
        .getReceivingByIdStore(id)
        .then((response) => {
          const sectors = response?.data?.data?.sectors ?? response?.data?.data;
          const limits = response?.data?.data?.limits ?? [];
 
          const sortedData = sectors.sort(
            (
              a: { receivingSectorId: number; productManagerId: number },
              b: { receivingSectorId: number; productManagerId: number }
            ) => {
              if (a.receivingSectorId === b.receivingSectorId) {
                return a.productManagerId - b.productManagerId;
              } else {
                return a.receivingSectorId - b.receivingSectorId;
              }
            }
          );
 
          setParamsData(sortedData);
          setParamsDataOriginal(sortedData);
          updateLimits(limits); // 👈 ATUALIZA OS LIMITES
 
          setLoadingEdit(false);
        })
        .catch((ex) => {
          setLoading(false);
        });
    },
    [updateLimits]
  );
 
  const clearParams = useCallback(() => {
    setParams({
      storeId: 0,
      ferragem: {
        receivingSectorId: 1,
        angela: {
          id: 0,
          productManagerId: 13,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        everton: {
          id: 6,
          productManagerId: 6,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        danubia: {
          id: 3,
          productManagerId: 3,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        mappa: {
          id: 24,
          productManagerId: 24,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        pedro: {
          id: 0,
          productManagerId: 35,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
      },
      chaparia: {
        receivingSectorId: 2,
        angela: {
          id: 0,
          productManagerId: 13,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        everton: {
          id: 0,
          productManagerId: 6,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        danubia: {
          id: 0,
          productManagerId: 3,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        mappa: {
          id: 0,
          productManagerId: 24,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
        pedro: {
          id: 0,
          productManagerId: 35,
          segunda: 0,
          terca: 0,
          quarta: 0,
          quinta: 0,
          sexta: 0,
        },
      },
    });
    // Reset limits to original structure
    updateLimits([...originalLimits]);
  }, [updateLimits, originalLimits]);
 
  const getSupplierVagas = useCallback(
    async (storeID: number) => {
      // setLoadingSupplier(true);(true);
      let newParams = {};
 
      receiving
        .getSupplierGP(storeID)
        .then((response) => {
          // setLoadingSupplier(true);(false);
          updateDataSupplier(response.data?.data);
          setNewEntry(null);
        })
        .catch(() => {
          updateDataSupplier([]);
          // setLoadingSupplier(true);(false);
        });
    },
    [updateDataSupplier]
  );
 
  const postSupplierVagas = useCallback(
    async (obj: any, storeId: any) => {
      // setLoadingSupplier(true);(true);
      let newParams = {};
      setLoadingUpdate(true);
 
      receiving
        .postSupplierGP(obj)
        .then((response) => {
          // setLoadingSupplier(true);(false);
          const { data } = response;
          const message = data?.message
            ? data?.message
            : "Cadastro Realizado com Sucesso";
          toast({
            title: message,
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          setNewEntry(null);
          setLoadingUpdate(false);
 
          getSupplierVagas(storeId);
        })
        .catch((e: any) => {
          const { data } = e.response;
 
          const message = data?.message
            ? data?.message
            : "Ocorreu um problema interno. Tente novamente mais tarde";
          toast({
            title: "Error.",
            description: message,
            position: "top",
            status: "error",
            duration: 2000,
 
            isClosable: true,
          });
          setLoadingUpdate(false);
 
          // setLoadingSupplier(true);(false);
        });
    },
    [updateDataSupplier]
  );
 
  const putSupplierVagas = useCallback(async (obj: any, storeId: any) => {
    // setLoadingSupplier(true);(true);
    let newParams = {};
    setLoadingUpdate(true);
 
    receiving
      .putSupplierGP(obj)
      .then((response) => {
        // setLoadingSupplier(true);(false);
        toast({
          title: "Alteração realizada com sucesso.",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        setLoadingUpdate(false);
 
        getSupplierVagas(storeId);
      })
      .catch((e: any) => {
        const { data } = e.response;
 
        const message = data?.message
          ? data?.message
          : "Ocorreu um problema interno. Tente novamente mais tarde";
        toast({
          title: "Error.",
          description: message,
          position: "top",
          status: "error",
          duration: 2000,
 
          isClosable: true,
        });
        setLoadingUpdate(false);
        // setLoadingSupplier(true);(false);
      });
  }, []);
  const deleteSupplierVagas = useCallback(async (id: any, storeID: any) => {
    // setLoadingSupplier(true);(true);
    let newParams = {};
 
    receiving
      .deleteSupplierGP(id)
      .then((response) => {
        toast({
          title: "Registro removido com sucesso.",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        // setLoadingSupplier(true);(false);
        getSupplierVagas(storeID);
      })
      .catch((e: any) => {
        const { data } = e.response;
 
        const message = data?.message
          ? data?.message
          : "Ocorreu um problema interno. Tente novamente mais tarde";
        toast({
          title: "Error.",
          description: message,
          position: "top",
          status: "error",
          duration: 2000,
 
          isClosable: true,
        });
        // setLoadingSupplier(true);(false);
      });
  }, []);
 
  const getGPSupplier = useCallback(
    async (storeID: any, supplierID: any) => {
      setLoadingGPSupplier(true);
      let newParams = {};
 
      receiving
        .getGPSupplier(storeID, supplierID)
        .then((response) => {
          setLoadingGPSupplier(false);
          const convertedResponse = response.data?.data?.managers.map(
            (item: { productManagerId: any; name: any }) => ({
              label: `${item.productManagerId} - ${item.name}`,
              value: item.productManagerId,
            })
          );
 
          const convertedResponseUser = response.data?.data?.users.map(
            (item: { id: any; name: any }) => ({
              label: `${item.id} - ${item.name}`,
              value: item.id,
            })
          );
 
          updateDataGPSupplier(convertedResponse);
          updateDataUserSupplier(convertedResponseUser);
        })
        .catch(() => {
          updateDataGPSupplier([]);
          setLoadingGPSupplier(false);
        });
    },
    [updateDataGPSupplier]
  );
 
  const fecharModal = () => {
    onClose();
  };
 
  const handleUpdateLimit = useCallback(
    (receivingSectorId: number, day: keyof ParamsDataItem, value: number) => {
      updateLimits((draft) => {
        const target = draft.find(
          (l) => l.receivingSectorId === receivingSectorId
        );
        if (target) {
          target[day] = value;
        }
      });
    },
    [updateLimits]
  );
 
  const returnDataOriginal = useCallback(async () => {
    setParamsData(paramsDataOriginal);
    updateLimits([...originalLimits]);
  }, [paramsDataOriginal, originalLimits, updateLimits]);
 
  return (
    <ReceivingSectorContext.Provider
      value={{
        loading,
        loadingEdit,
        data,
        isFirstData,
        dataOriginal,
        params,
        paramsData,
        dataScruture,
        getDataStructure,
        setParamsData,
        getData,
        deleteData,
        putData,
        handleDynamic,
        handleStore,
        getDataByIdStore,
        postData,
        clearParams,
        getReceivingStoreUpdate,
        handleDynamicCreate,
        dataHistoric,
        loadingHistoric,
        getDataHistoric,
        getSupplierVagas,
        postSupplierVagas,
        dataUserSupplier,
        dataSupplier,
        loadingSupplier,
        putSupplierVagas,
        deleteSupplierVagas,
        loadingGPSupplier,
        newEntry,
        isOpenUpdate,
        setIsOpenUpdate,
        isOpenCreate,
        setNewEntry,
        setIsOpenCreate,
        fecharModal,
        dataGPSupplier,
        loadingUpdate,
        getGPSupplier,
        editEntry,
        setEditEntry,
        editIdx,
        returnDataOriginal,
        setEditIdx,
        handleUpdateLimit,
        limits,
      }}
    >
      {children}
    </ReceivingSectorContext.Provider>
  );
};
 
export default ReceivingSectorProvider;
export const ReceivingSectorContext = createContext<IReceivingSectorContext>(
  {} as IReceivingSectorContext
);